import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './PassaggioDocumentale.css';

const BASE_URL = 'http://localhost:9000/s3'; // Adjust if needed

const FormPassaggioDocumentale = () => {
    const [loading, setLoading] = useState(false);
    const [logs, setLogs] = useState([]);
    const [s3Data, setS3Data] = useState([]);

    // State for each form section
    const [downloadForm, setDownloadForm] = useState({ bucket: '', prefix: '', localPath: './data' });
    const [renameForm, setRenameForm] = useState({ fileFolder: './data', outputDir: './data/renamed', resultFileDir: './data' });
    const [noApostrofiForm, setNoApostrofiForm] = useState({ directoryPath: './data/renamed' });
    const [xmlForm, setXmlForm] = useState({ fileFolder: './data/renamed', outputDir: './data/xml', yearToUse: '2021', resultFileDir: './data', compagnia: '05' });
    const [datForm, setDatForm] = useState({ xmlFolder: './data/xml', outputDir: './data/dat', datFileName: 'lista_xml.dat' });
    const [zipForm, setZipForm] = useState({ inputFolder: './data/xml', brand: 'cattolica', zipFileName: 'output.zip' });

    const addLog = (message) => {
        setLogs(prev => [`[${new Date().toLocaleTimeString()}] ${message}`, ...prev]);
    };

    const handleApiError = (error, action) => {
        console.error(error);
        const errorMsg = error.response?.data?.message || error.response?.data?.error || error.message;
        addLog(`Error ${action}: ${errorMsg}`);
        setLoading(false);
    };

    // 1. Get Data Passaggi
    const fetchS3Data = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${BASE_URL}/getDataPassaggi`);
            setS3Data(res.data);
            addLog(`Fetched S3 Data: ${res.data.length} brands found.`);
            // Auto-fill bucket if empty and data exists
            if (res.data.length > 0 && !downloadForm.bucket) {
                 // Logic to pick a bucket if needed, or just let user see available
            }
        } catch (error) {
            handleApiError(error, 'fetching S3 data');
        } finally {
            setLoading(false);
        }
    };

    // 2. Download from S3
    const handleDownload = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await axios.post(`${BASE_URL}/downloadFromS3`, downloadForm);
            addLog('Download from S3 completed successfully.');
        } catch (error) {
            handleApiError(error, 'downloading from S3');
        } finally {
            setLoading(false);
        }
    };

    // 3. Change Names
    const handleChangeNames = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await axios.post(`${BASE_URL}/changeNames`, renameForm);
            addLog(res.data.message || 'Change names completed.');
            if (res.data.curl) addLog(`Next step suggested: ${res.data.curl}`);
        } catch (error) {
            handleApiError(error, 'changing names');
        } finally {
            setLoading(false);
        }
    };

    // 4. No Apostrofi
    const handleNoApostrofi = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await axios.post(`${BASE_URL}/noApostrofi`, noApostrofiForm);
            addLog(res.data.message || 'No apostrofi check completed.');
        } catch (error) {
            handleApiError(error, 'removing apostrophes');
        } finally {
            setLoading(false);
        }
    };

    // 5. Create XML
    const handleCreateXml = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await axios.post(`${BASE_URL}/createXml`, xmlForm);
            addLog(res.data.messagge || 'XML creation completed.');
        } catch (error) {
            handleApiError(error, 'creating XML');
        } finally {
            setLoading(false);
        }
    };

    // 6. Create DAT
    const handleCreateDat = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await axios.post(`${BASE_URL}/createFileDat`, datForm);
            addLog(res.data.message || 'DAT file created.');
        } catch (error) {
            handleApiError(error, 'creating DAT file');
        } finally {
            setLoading(false);
        }
    };

    // 7. Create Zip
    const handleCreateZip = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await axios.post(`${BASE_URL}/createFileZip`, zipForm);
            addLog(res.data.message || 'Zip created.');
            if (res.data.signedUrl) {
                addLog(`Download URL: ${res.data.signedUrl}`);
            }
        } catch (error) {
            handleApiError(error, 'creating Zip');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="main-container-passaggio-documentale" style={{ display: 'flex', flexDirection: 'column', gap: '20px', overflowY: 'auto' }}>
            
            {/* Logs Section */}
            <div style={{ background: '#333', color: '#fff', padding: '10px', borderRadius: '5px', maxHeight: '150px', overflowY: 'auto' }}>
                <h4>Logs</h4>
                {logs.length === 0 && <p style={{ fontSize: '0.8em' }}>No logs yet...</p>}
                {logs.map((log, i) => <div key={i} style={{ fontSize: '0.8em' }}>{log}</div>)}
            </div>

            {loading && <div style={{ color: 'blue', fontWeight: 'bold' }}>Processing...</div>}
            {/* 1. Get Data */}
            <div className="card-section item_dashboard" style={{ border: '1px solid #ccc', padding: '15px', borderRadius: '8px' }}>
                <h3 className="azienda-title">1. Available S3 Data</h3>
                <button onClick={fetchS3Data} disabled={loading}>Fetch Available Data</button>
                {s3Data.length > 0 && (
                    <ul style={{ maxHeight: '100px', overflowY: 'auto' }}>
                        {s3Data.map((b, i) => (
                            <li key={i}>
                                <strong>{b.brand}</strong>: {b.files ? b.files.length : 0} files
                            </li>
                        ))}
                    </ul>
                )}
            </div>

            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                
                {/* 2. Download */}
                <div className='item_dashboard'>
                <form  onSubmit={handleDownload} style={formStyle}>
                    <h4>2. Download from S3</h4>
                    <label>Bucket: <input type="text" value={downloadForm.bucket} onChange={e => setDownloadForm({...downloadForm, bucket: e.target.value})} /></label>
                    <label>Prefix: <input type="text" value={downloadForm.prefix} onChange={e => setDownloadForm({...downloadForm, prefix: e.target.value})} /></label>
                    <label>Local Path: <input type="text" value={downloadForm.localPath} onChange={e => setDownloadForm({...downloadForm, localPath: e.target.value})} /></label>
                    <button type="submit" disabled={loading}>Download</button>
                </form>
                </div>

                {/* 3. Rename */}
                <div className='item_dashboard' >
                <form onSubmit={handleChangeNames} style={formStyle}>
                    <h4>3. Validazione Nomi</h4>
                    <label>File Folder: <input type="text" value={renameForm.fileFolder} onChange={e => setRenameForm({...renameForm, fileFolder: e.target.value})} /></label>
                    <label>Output Dir: <input type="text" value={renameForm.outputDir} onChange={e => setRenameForm({...renameForm, outputDir: e.target.value})} /></label>
                    <label>Result Dir: <input type="text" value={renameForm.resultFileDir} onChange={e => setRenameForm({...renameForm, resultFileDir: e.target.value})} /></label>
                    <button type="submit" disabled={loading}>Rinomina Files</button>
                </form>
                </div>

                {/* 4. No Apostrofi */}
                <div className='item_dashboard'>
                <form onSubmit={handleNoApostrofi} style={formStyle}>
                    <h4>4. Rimuovi Apostrofi</h4>
                    <label>Directory Path: <input type="text" value={noApostrofiForm.directoryPath} onChange={e => setNoApostrofiForm({...noApostrofiForm, directoryPath: e.target.value})} /></label>
                    <button type="submit" disabled={loading}>Esegui Pulizia</button>
                </form>
                </div>

                {/* 5. Create XML */}
                <div className='item_dashboard'>
                <form onSubmit={handleCreateXml} style={formStyle}>
                    <h4>5. Create XML</h4>
                    <label>File Folder: <input type="text" value={xmlForm.fileFolder} onChange={e => setXmlForm({...xmlForm, fileFolder: e.target.value})} /></label>
                    <label>Output Dir: <input type="text" value={xmlForm.outputDir} onChange={e => setXmlForm({...xmlForm, outputDir: e.target.value})} /></label>
                    <label>Year: <input type="text" value={xmlForm.yearToUse} onChange={e => setXmlForm({...xmlForm, yearToUse: e.target.value})} /></label>
                    <label>Compagnia: 
                        <select value={xmlForm.compagnia} onChange={e => setXmlForm({...xmlForm, compagnia: e.target.value})}>
                            <option value="05">Generali (05)</option>
                            <option value="06">Cattolica (06)</option> {/* Assuming 06 for Cattolica based on code logic */}
                        </select>
                    </label>
                    <button type="submit" disabled={loading}>Genera XML</button>
                </form>
                </div>

                {/* 6. Create DAT */}
                <div className='item_dashboard'>
                <form onSubmit={handleCreateDat} style={formStyle}>
                    <h4>6. Create DAT</h4>
                    <label>XML Folder: <input type="text" value={datForm.xmlFolder} onChange={e => setDatForm({...datForm, xmlFolder: e.target.value})} /></label>
                    <label>Output Dir: <input type="text" value={datForm.outputDir} onChange={e => setDatForm({...datForm, outputDir: e.target.value})} /></label>
                    <label>DAT Filename: <input type="text" value={datForm.datFileName} onChange={e => setDatForm({...datForm, datFileName: e.target.value})} /></label>
                    <button type="submit" disabled={loading}>Genera DAT</button>
                </form>
                </div>
                {/* 7. Create ZIP */}
                <div className='item_dashboard'>
                <form onSubmit={handleCreateZip} style={formStyle}>
                    <h4>7. Create ZIP</h4>
                    <label>Input Folder: <input type="text" value={zipForm.inputFolder} onChange={e => setZipForm({...zipForm, inputFolder: e.target.value})} /></label>
                    <label>Brand: 
                        <select value={zipForm.brand} onChange={e => setZipForm({...zipForm, brand: e.target.value})}>
                            <option value="cattolica">Cattolica</option>
                            <option value="generali">Generali</option>
                        </select>
                    </label>
                    <label>Zip Filename: <input type="text" value={zipForm.zipFileName} onChange={e => setZipForm({...zipForm, zipFileName: e.target.value})} /></label>
                    <button type="submit" disabled={loading}>Crea e Carica Zip</button>
                </form>
                </div>

            </div>
        </div>
    );
}

const formStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    border: '1px solid #ddd',
    padding: '15px',
    borderRadius: '8px',
    minWidth: '300px',
    flex: '1',
    width: '15vw',
   // backgroundColor: '#fff' // Ensure readibility
};

export default FormPassaggioDocumentale;